import api from './api';

export type ReplacementReason = 'vakantie' | 'ziekte' | 'anders';
export type ReplacementStatus = 'active' | 'completed' | 'cancelled';

export interface Replacement {
  id: number;
  connection_id: number;
  professional_id: string;
  replacement_name: string;
  replacement_email: string;
  replacement_phone?: string | null;
  is_belagom_member: boolean;
  quality_check_confirmed: boolean;
  start_date: string;
  end_date?: string | null;
  reason: ReplacementReason;
  reason_description?: string | null;
  status: ReplacementStatus;
  created_at: string;
  updated_at: string;
}

export interface CreateReplacementRequest {
  replacement_name: string;
  replacement_email: string;
  replacement_phone?: string;
  is_belagom_member: boolean;
  quality_check_confirmed: boolean;
  start_date: string;
  end_date?: string;
  reason: ReplacementReason;
  reason_description?: string;
}

export const replacementApi = {
  // Professional: list replacements for a connection
  listForProfessional: async (connectionId: number): Promise<Replacement[]> => {
    const response = await api.get(`/professional/connections/${connectionId}/replacements`);
    return response.data.data || [];
  },

  // Professional: register a new replacement
  create: async (connectionId: number, data: CreateReplacementRequest): Promise<Replacement> => {
    const response = await api.post(`/professional/connections/${connectionId}/replacements`, data);
    return response.data.data;
  },

  // Professional: update status (complete or cancel)
  updateStatus: async (connectionId: number, replacementId: number, status: 'completed' | 'cancelled'): Promise<Replacement> => {
    const response = await api.patch(`/professional/connections/${connectionId}/replacements/${replacementId}`, { status });
    return response.data.data;
  },

  // Employer: view replacements for a connection (read-only)
  listForEmployer: async (connectionId: number): Promise<Replacement[]> => {
    const response = await api.get(`/employer/connections/${connectionId}/replacements`);
    return response.data.data || [];
  }
};
